import React, { useEffect, useState } from 'react';
import {
  Container,
} from 'reactstrap';
import Parse from 'html-react-parser';
import { useIntl } from 'react-intl';

import { APIgetAppChangelog } from '../../api/Admin';

import Loading from '../../components/Loading';

const AdminPanelChangelog = () => {
  const [changelog, setChangelog] = useState(null);

  const intl = useIntl();

  useEffect(() => {
    APIgetAppChangelog().then((response) => {
      setChangelog(response.data);
    });
  }, []);

  return (
    <div className="main-content split-content page-changelog">
      <div className="split-content-wrapper">
        <Container fluid>
          <header className="page-header">
            <h2 className="page-title">
              {intl.formatMessage({ defaultMessage: 'Changelog' })}
            </h2>
          </header>
          <div className="content-wrapper changelog-wrapper">
            <div className="changelog">
              {changelog ? (
                Parse(changelog)
              ) : (
                <Loading />
              )}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AdminPanelChangelog;
